// Navigation list
const navList = [
    { name: 'Home', to: '/', current: false },
    { name: 'Service', to: '/#service', current: false },
    { name: 'Doctors', to: '/doctors', current: false },
    { name: 'Shop', to: '/shop', current: false },
    { name: 'Appointment', to: '/appointment', current: false },
]


export { navList };